import {createContext, Dispatch, SetStateAction} from "react"
import {ProfileDB} from "../models/ProfileDB.model"

interface ProfileContextProps {
  profile?: ProfileDB,
  profileReplCnt?: number,
  setProfileReplCnt: Dispatch<SetStateAction<number>>
}

export const ProfileContext = createContext<ProfileContextProps>({
  setProfileReplCnt: () => {

  }
})
